import {CommonObject} from './common-object';

export class Label extends CommonObject {
  name: string;
  backcolor: string;
  textcolor: string;
}
